import React from 'react';

import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const EquipmentItemActionInsert = ({
    onToggleCreateSensorModal,
    onToggleCreateEquipmentAreaModal,
    onToggleCreateEquipmentSystemModal,
    onToggleDeleteEquipmentModal,
    onToggleEditEquipmentModal
}) => (
    <div className={classes.agentActions}>
        <ActionsPanelItem
            title="Edit Equipment"
            iconUrl="/assets/images/equipmentTreeIcon.svg"
            onClick={() => onToggleEditEquipmentModal(true)}
        />
        <ActionsPanelItem
            title="Add Sensor to Equipment"
            iconUrl="/assets/images/sensorTreeIcon.svg"
            onClick={() => onToggleCreateSensorModal(true)}
        />
        <ActionsPanelItem
            title="Add Equipment to Areas"
            iconUrl="/assets/images/areaTreeIcon.svg"
            onClick={() => onToggleCreateEquipmentAreaModal(true)}
        />
        <ActionsPanelItem
            title="Associate Equipment with Systems"
            iconUrl="/assets/images/systemTreeIcon.svg"
            onClick={() => onToggleCreateEquipmentSystemModal(true)}
        />
        <ActionsPanelItem
            title="Delete Equipment"
            iconUrl="/assets/images/deleteIconColor.svg"
            onClick={() => onToggleDeleteEquipmentModal(true)}
        />
    </div>
);

EquipmentItemActionInsert.defaultProps = {
    onToggleCreateSensorModal:    () => {},
    onToggleDeleteEquipmentModal: () => {},
    onToggleEditEquipmentModal:   () => {}
};

EquipmentItemActionInsert.propTypes = {
    onToggleCreateSensorModal:    func,
    onToggleDeleteEquipmentModal: func,
    onToggleEditEquipmentModal:   func
};

export default EquipmentItemActionInsert;
